export default {
  'startProcessInstance.startMappings': 'Mapeos de inicio',
  'startProcessInstance.responseMappings': 'Mapeos de respuesta',
  'startProcessInstance.mapping': 'Mapeo',
  'startProcessInstance.addMapping': 'Agregar mapeo',
};
